var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudServices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 17.8333H7.49999C6.41821 17.8331 5.35782 17.532 4.4373 16.9637C3.51679 16.3955 2.77242 15.5825 2.28738 14.6155C1.80234 13.6486 1.59574 12.5658 1.69065 11.4882C1.78557 10.4106 2.17826 9.38059 2.82486 8.51332C3.47146 7.64605 4.34649 6.97567 5.35216 6.57708C6.35783 6.17849 7.45453 6.0674 8.5197 6.25623C9.58487 6.44505 10.5766 6.92635 11.3839 7.64634C12.1913 8.36634 12.7826 9.29665 13.0917 10.3333H14.5833C15.5779 10.3333 16.5317 10.7284 17.235 11.4317C17.9382 12.135 18.3333 13.0888 18.3333 14.0833C18.3333 15.0779 17.9382 16.0317 17.235 16.735C16.5317 17.4383 15.5779 17.8333 14.5833 17.8333Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudServices);
export default __webpack_public_path__ + "static/media/CloudServices.87d96755a6b91dccc1ae71c5593e7cff.svg";
export { ForwardRef as ReactComponent };